import {createAction} from '@reduxjs/toolkit'

// violations logs download actions
export const downloadViolationsLogs = createAction('downloadViolationsLogs')
export const downloadViolationsLogsSuccess = createAction<string>(
  'downloadViolationsLogsSuccess',
)
export const downloadViolationsLogsFailure = createAction(
  'downloadViolationsLogsFailure',
)
export const resetDownloadViolationsLogsState = createAction(
  'resetDownloadViolationsLogsState',
)
